import { Box, Flex, Spacer, Text } from '@chakra-ui/react'
import FormBrandMultiSelect from '../forms/FormBrandMultiSelect'
import FormMemberMultiSelect from '../forms/FormMemberMultiSelect'
import FormMemberSelect from '../forms/FormMemberSelect'
import FilterModeToggle from '../forms/FilterModeToggle'
import { useGlobalFilterStore } from '../../../stores/globalFilterStore'
import FilterPopover from './FilterPopover'

const GlobalFilterPopover = () => {
  const {
    member,
    brands,
    memberMode,
    brandMode,
    excludedMembers,
    excludedBrands,
    setMember,
    setBrands,
    setMemberMode,
    setBrandMode,
    setExcludedMembers,
    setExcludedBrands,
  } = useGlobalFilterStore()

  const isActive = !!member || brands.length > 0 || excludedMembers.length > 0 || excludedBrands.length > 0

  // With the member field in exclude mode there is no included member to scope
  // brand search by, so the brand dropdown lists all brands.
  const brandScopeMemberId = memberMode === 'include' ? member?.id ?? undefined : undefined

  return (
    <FilterPopover subheader="Global filter" isActive={isActive}>
      <Box w={{ base: '100%', md: '300px' }}>
        <Flex alignItems="center" justifyContent="space-between" gap="12px" mb="4px">
          <Text color="neutral.900" fontWeight="400" textStyle="b-sm">
            Member
          </Text>
          <FilterModeToggle mode={memberMode} onChange={setMemberMode} aria-label="Member filter mode" />
        </Flex>
        {/* The row above owns the label, so the pickers suppress their own. */}
        {memberMode === 'include' ? (
          <FormMemberSelect
            value={member ? { ...member, image: member.image ?? null } : null}
            onAdd={(item) => setMember(item)}
            name="member"
            hideLabel
            onRemove={() => {
              setMember(null)
              setBrands([]) // clearing the included member clears its brands
            }}
          />
        ) : (
          <FormMemberMultiSelect
            value={excludedMembers.map((m) => ({ ...m, image: m.image ?? null }))}
            onChange={(items) => setExcludedMembers(items)}
            name="member"
            placeholder="Search for members to exclude"
            hideLabel
          />
        )}

        <Spacer h="12px" />

        <Flex alignItems="center" justifyContent="space-between" gap="12px" mb="4px">
          <Text color="neutral.900" fontWeight="400" textStyle="b-sm">
            Brand
          </Text>
          <FilterModeToggle mode={brandMode} onChange={setBrandMode} aria-label="Brand filter mode" />
        </Flex>
        {brandMode === 'include' ? (
          <FormBrandMultiSelect
            value={brands.map((b) => ({ ...b, logo: b.logo ?? null }))}
            onChange={(items) => setBrands(items)}
            name="brand"
            memberId={brandScopeMemberId}
            hideLabel
          />
        ) : (
          <FormBrandMultiSelect
            value={excludedBrands.map((b) => ({ ...b, logo: b.logo ?? null }))}
            onChange={(items) => setExcludedBrands(items)}
            name="brand"
            placeholder="Search for brands to exclude"
            memberId={brandScopeMemberId}
            hideLabel
          />
        )}
      </Box>
    </FilterPopover>
  )
}

export default GlobalFilterPopover
